import { useRef } from "react";

export const VideoEmbed = ({ src, poster, testid = "video-embed" }) => {
  const videoRef = useRef(null);
  const retries = useRef(0);

  const handleError = () => {
    if (retries.current >= 3 || !videoRef.current) return;
    retries.current += 1;
    const v = videoRef.current;
    const resumeAt = v.currentTime;
    setTimeout(() => {
      v.src = `${src}${src.includes("?") ? "&" : "?"}retry=${retries.current}`;
      v.load();
      if (resumeAt > 0) v.currentTime = resumeAt;
    }, 800 * retries.current);
  };

  return (
    <video
      ref={videoRef}
      src={src}
      poster={poster}
      controls
      playsInline
      preload="metadata"
      onError={handleError}
      data-testid={testid}
    />
  );
};
